module.exports = __webpack_public_path__ + "static/media/arch7.6285430e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arch7.jpg
// module id = 5793
// module chunks = 0